<template>
  <div class="subscription-page">
    <ModalDiversityInputs />
    <Hero
      image="banner-home.jpeg"
      layout="md"
      title="Cadastre seu Currículo"
      class="darker"
    />

    <div class="row pb-5">
      <div class="col-12 col-lg-10 mx-auto mt-n4">
        <div class="row">
          <div class="col-2">
            <ProfileSidebarMenu
              personalData
              education
              professionalExp
              language
            />
          </div>

          <div class="col-12 col-md-10">
            <div class="bg-white shadow p-5 rounded-xl position-relative">
              <LoaderContent
                v-if="!graphql_loaded"
                :welcomeMessage="false"
                :alignSpinnerTop="true"
                loaderContentClass="rounded-xl"
              />
              <div v-else>
                <BoxPersonalData
                  ref="box-personal-data"
                  format="inline-form"
                  id="box-personal-data"
                />

                <div class="py-4"></div>

                <BoxEducation
                  ref="box-education"
                  format="inline-form"
                  id="box-education"
                />

                <div class="py-4"></div>

                <BoxProfessionalExp
                  ref="box-professional-experience"
                  format="inline-form"
                  id="box-professional-experience"
                />

                <div class="py-4"></div>

                <BoxLanguage
                  ref="box-language"
                  format="inline-form"
                  id="box-language"
                />

                <div class="row mt-3 pt-5">
                  <div class="col-12 text-center">
                    <button
                      type="button"
                      class="btn btn-lg btn-wl-primary"
                      @click="submit()"
                    >
                      <span v-if="!isSaving">Deixar meu Currículo</span>
                      <EllipsisLoader v-else />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import LoaderContent from "ninenine-white-label/src/components/Loader/LoaderContent.vue";
import EllipsisLoader from "ninenine-white-label/src/components/Loader/EllipsisLoader.vue";
import BoxPersonalData from "ninenine-white-label/src/components/PersonalData/BoxPersonalData.vue";
import BoxEducation from "ninenine-white-label/src/components/Education/BoxEducation.vue";
import BoxProfessionalExp from "ninenine-white-label/src/components/ProfessionalExp/BoxProfessionalExp.vue";
import BoxLanguage from "ninenine-white-label/src/components/Language/BoxLanguage.vue";
import ProfileSidebarMenu from "@/components/ProfileSidebarMenu.vue";
import ModalDiversityInputs from "@/components/ModalDiversityInputs.vue";

export default {
  name: "RegisterProfile",

  data() {
    return {
      graphql_loaded: false,
      isSaving: false,
    };
  },

  components: {
    Hero,
    LoaderContent,
    EllipsisLoader,
    BoxPersonalData,
    BoxEducation,
    BoxProfessionalExp,
    BoxLanguage,
    ProfileSidebarMenu,
    ModalDiversityInputs,
  },

  mounted() {
    setTimeout(() => this.removeAutoFillSelectize(), 500);
    this.getProfile();
  },

  methods: {
    scroll() {
      window.scroll(0, 1);
    },

    getProfile() {
      let requestDomainReturn = "";

      if (this.$store.state.domains.countries.length == 0) {
        requestDomainReturn += `countries { id, name },`;
      }
      if (this.$store.state.domains.genders.length == 0) {
        requestDomainReturn += `genders { id, description },`;
      }
      if (this.$store.state.domains.maritalStatus.length == 0) {
        requestDomainReturn += `maritalStatus {id, description},`;
      }
      if (this.$store.state.domains.states.length == 0) {
        requestDomainReturn += `states { id, name, abbr },`;
      }
      if (this.$store.state.domains.disabilities.length == 0) {
        requestDomainReturn += `disabilities { id, name },`;
      }
      if (this.$store.state.domains.education_levels.length == 0) {
        requestDomainReturn += `educationLevels {id, description},`;
      }
      if (this.$store.state.domains.education_status.length == 0) {
        requestDomainReturn += `educationStatus {id, description},`;
      }
      if (this.$store.state.domains.companies.length == 0) {
        requestDomainReturn += `companies {id, name},`;
      }
      if (this.$store.state.domains.professional_experience_areas.length == 0) {
        requestDomainReturn += `professionalExperienceAreas {id, name},`;
      }
      if (
        this.$store.state.domains.professional_experience_levels.length == 0
      ) {
        requestDomainReturn += `professionalExperienceLevels {id, name}`;
      }
      if (this.$store.state.domains.languages.length == 0) {
        requestDomainReturn += `languages {id, name},`;
      }
      if (this.$store.state.domains.language_proficiencies.length == 0) {
        requestDomainReturn += `languageProficiencies {id, description},`;
      }

      requestDomainReturn += `genders { id, description },`;
      requestDomainReturn += `raceAndEthnicities { id, description },`;
      requestDomainReturn += `pronouns { id, description },`;
      requestDomainReturn += `personalIncomes { id, description },`;
      requestDomainReturn += `familyIncomes { id, description },`;
      requestDomainReturn += `sexualOrientations {id, description},`;
      requestDomainReturn += `disabilities { id, name },`;

      if (requestDomainReturn.length > 0) {
        requestDomainReturn = `domains {
          ${requestDomainReturn}
        },`;
      }

      this.$store
        .dispatch(
          "graphql_queries/query",
          `
        ${requestDomainReturn}
        user( id: "${this.$store.state.user.profile.id}" ){
          avatar,
          medicalReports {
            id,
            name,
            file
          },
          profile{
            firstname,
            lastname,
            socialName,
            email,
            nationality,
            cpf,
            passport,
            gender,
            maritalStatus,
            phone,
            birthday,
            whatDoYouLove,
            raceAndEthnicity,
            pronoun,
            sexualOrientation,
            personalIncome,
            familyIncome,
            descriptionHelpSelectionProcess,
            needHelpSelectionProcess,

            location {
              zipcode,
              street,
              number,
              complement,
              neighborhood,
              stateId,
              city
            },

            disabilities {
              disabilityId,
              name
            },

            educations {
              id,
              institutionName,
              level,
              courseName,
              startDate,
              endDate,
              stateId
            },

            professionalExperiences {
              id,
              role,
              responsabilities,
              company,
              startYear,
              endYear
            },

            languageProficiencies {
              id,
              language,
              proficiency
            },

          }
        },
      `
        )
        .then((results) => {
          this.graphql_loaded = true;
          setTimeout(() => this.$EventBus.$emit("editingPersonalData"), 100);
        });
    },

    async submit() {
      let canSubmit = false;
      this.$EventBus.$emit("storePersonalDataForm");

      if (this.$store.state.personalDataForm.error) {
        canSubmit = false;
        this.isSaving = false;
      } else {
        this.$store.commit("EDUCATIONS_FORMS");
        this.$EventBus.$emit("storeEducationFormInSequence");

        if (
          this.$store.state.user.profile.educations.length == 0 &&
          this.$store.state.educationsForms.find((form) => form.error)
        ) {
          canSubmit = false;
          this.isSaving = false;
          this.$swal(
            "Uoops",
            "Preencha corretamente sua formação",
            "error"
          ).then(() => {
            this.goToInvalidField(this.$refs["box-education"].$el);
          });
        } else {
          this.$store.commit("PROFESSIONAL_EXPERIENCES_FORMS");
          this.$EventBus.$emit("storeProfessionalExperienceFormInSequence");

          if (
            this.$store.state.flag_no_professional_experience == false &&
            this.$store.state.user.profile.professionalExperiences.length ==
              0 &&
            this.$store.state.professionalExperiencesForms.find(
              (form) => form.error
            )
          ) {
            canSubmit = false;
            this.isSaving = false;
            this.$swal(
              "Uoops",
              "Preencha corretamente sua experiência profissional",
              "error"
            ).then(() => {
              this.goToInvalidField(
                this.$refs["box-professional-experience"].$el
              );
            });
          } else {
            this.$store.commit("LANGUAGES_FORMS");
            this.$EventBus.$emit("storeLanguageFormInSequence");

            canSubmit = true;
          }
        }
      }

      if (canSubmit) {
        this.isSaving = true;

        const personalData = this.$store.state.personalDataForm.data;
        const savePersonal = personalData
          ? await this.$store.dispatch("user/personalDataUpdate", personalData)
          : null;

        if (savePersonal && savePersonal.error) {
          this.$swal(
            "Uoops",
            "Ocorreu um erro ao salvar suas informações",
            "error"
          );
          this.isSaving = false;
          return;
        }

        const educationsForms = this.$store.state.educationsForms;
        let saveEducation;
        for (const educationData of educationsForms) {
          saveEducation = await this.$store.dispatch(
            "user/educationCreateUpdate",
            educationData
          );
          if (saveEducation.error) {
            this.$swal(
              "Uoops",
              "Ocorreu um erro ao salvar sua formação",
              "error"
            );
            this.isSaving = false;
            return;
          }
        }

        this.$store.state.flag_no_professional_experience == true &&
          this.$store.commit("PROFESSIONAL_EXPERIENCES_FORMS");
        const professionalExperiencesForms =
          this.$store.state.professionalExperiencesForms;
        let saveProfessional;
        for (const professionalExperienceData of professionalExperiencesForms) {
          saveProfessional = await this.$store.dispatch(
            "user/professionalExpCreateUpdate",
            professionalExperienceData
          );
          if (saveProfessional.error) {
            this.$swal(
              "Uoops",
              "Ocorreu um erro ao salvar sua experiência profissional",
              "error"
            );
            this.isSaving = false;
            return;
          }
        }

        const languagesForms = this.$store.state.languagesForms;
        let saveLanguage;
        for (const languageData of languagesForms) {
          saveLanguage = await this.$store.dispatch(
            "user/languageCreateUpdate",
            languageData
          );
          if (saveLanguage.error) {
            this.$swal(
              "Uoops",
              "Ocorreu um erro ao salvar seu idioma",
              "error"
            );
            this.isSaving = false;
            return;
          }
        }

        const follow = this.$store.dispatch("user/followCompany");
        if (follow.error) {
          this.$swal(
            "Uoops",
            "Ocorreu um problema ao deixar seu currículo",
            "error"
          );
        } else {
          this.isSaving = false;

          await this.$store.dispatch(
            'graphql_queries/query',
            `user( id: "${this.$store.state.user.profile.id}" ){
              profile{
                socialName,
              }
            }`,
          )

          this.$swal({
            title: "Pronto",
            text: "Seu currículo está disponível para Talentos na Pista!",
            type: "success",
            showCancelButton: false,
          }).then((result) => {
            this.$router.push("/vagas");
          });
        }
      }
    },
  },
};
</script>